import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { PropertyGroupApiData } from "../propertyGroupModal";

interface HeroSectionProps {
  formData: PropertyGroupApiData;
  onHeroChange: (field: "header" | "mainParagraph", value: string) => void;
  onQueryChange: (query: string) => void;
  onLanguageChange: (language_id: number) => void;
  onImageUpload: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onImageRemove: () => void;
  isUploadingImage: boolean;
  quillModules: any;
  quillFormats: string[];
}

const HeroSection: React.FC<HeroSectionProps> = ({
  formData,
  onHeroChange,
  onQueryChange,
  onLanguageChange,
  onImageUpload,
  onImageRemove,
  isUploadingImage,
  quillModules,
  quillFormats,
}) => {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Language *
          </label>
          <select
            value={formData.language_id || ""}
            onChange={(e) => onLanguageChange(Number(e.target.value))}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">Select Language</option>
            <option value={1}>Albania</option>
            <option value={2}>English</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Pyetja e chatit (Query) *
          </label>
          <input
            type="text"
            value={formData.query || ""}
            onChange={(e) => onQueryChange(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Ex.: Po kerkoj apartament per shitje ne Tirane"
          />
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Header (H1) *
        </label>
        <input
          type="text"
          value={formData.heroSection.header}
          onChange={(e) =>
            onHeroChange("header", e.target.value)
          }
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Main heading for the page"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Main Paragraph *
        </label>
        <ReactQuill
          theme="snow"
          value={formData.heroSection.mainParagraph}
          onChange={(value) =>
            onHeroChange("mainParagraph", value)
          }
          modules={quillModules}
          formats={quillFormats}
          placeholder="Main paragraph content"
        />
      </div>

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Hero Image
          </label>
          <div className="space-y-3">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Upload Hero Image
              </label>
              <div className="relative">
                <input
                  type="file"
                  accept="image/*"
                  onChange={onImageUpload}
                  disabled={isUploadingImage}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed text-sm"
                />
                {isUploadingImage && (
                  <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-75 rounded-md">
                    <div className="flex items-center space-x-2">
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
                      <span className="text-xs text-gray-600">
                        Uploading...
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
            {formData.heroSection.heroImage && !isUploadingImage && (
              <div className="flex items-center space-x-4 p-3 bg-gray-50 rounded-md">
                <img
                  src={formData.heroSection.heroImage}
                  alt="Hero Image Preview"
                  className="w-24 h-16 object-cover rounded border"
                />
                <div>
                  <p className="text-sm text-gray-700">
                    Hero Image Preview
                  </p>
                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      onImageRemove();
                    }}
                    className="text-xs text-red-600 hover:text-red-800">
                    Remove image
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;

